import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { ContentService } from '../../services/content.service';
import { OffersService } from '../../services/offers.service';

@Component({
  selector: 'app-offers-info',
  standalone: true,
  imports: [CommonModule, CarouselModule, ButtonModule, TagModule],
  templateUrl: './offers-info.component.html',
  styleUrl: './offers-info.component.scss'
})

export class OffersInfoComponent {
  @Input() offers: any = [];
  @Input() isVertical: boolean = false;
  @Input() numSlides: number = 4;
  @Input() title: string = '';
  responsiveOptions: any[] | undefined;

  constructor(
    private offersService: OffersService
  ) {
  }

  ngOnInit() {
    this.getOffers();

    this.responsiveOptions = [{
        breakpoint: '1199px',
        numVisible: 1,
        numScroll: 1
      },
      {
        breakpoint: '991px',
        numVisible: 2,
        numScroll: 1
      },
      {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1
      }
    ];
  }

  getOffers() {
    this.offersService.getOffers().subscribe((res: any) => {
      this.offers = res;
      console.log('res...', res)
    })
  }

}
